export const NEW_VARIATION_KEYS = ['isComplete', 'linkedDatapoints', 'repeaterIds'];
export const DUPLICATE_VARIATION_KEYS = ['content', 'title', 'isComplete', 'linkedDatapoints', 'repeaterIds'];
